import {Controller, useForm} from "react-hook-form";
import {
    checkPhoneCode,
    confirmEmail as confirmEmailApi,
    confirmPhone as confirmPhoneApi,
    update as updateApi
} from "../../../../api/customer";
import {useContext, useEffect, useState} from "react";
import Input from "react-phone-number-input/input";
import isEmail from "validator/es/lib/isEmail";
import {ReducerStateInterface} from "../../../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../../../GlobalReducer";
import moment from "moment";
import Subscription from "./Subscription";
import {checkEmail, checkEmailAndPhone} from "../../../../api/manzana";

export default function Registration() {
    const {control, register, reset, getValues, trigger, formState: {errors, dirtyFields}} = useForm({
        mode: "onChange"
    });

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [error, setError] = useState('')
    const [message, setMessage] = useState('')
    const [gender, setGender] = useState('')
    const [isEmailCommunicationApproved, setIsEmailCommunicationApproved] = useState(state.customer.is_email_communication_approved);
    const [isPhoneCommunicationApproved, setIsPhoneCommunicationApproved] = useState(state.customer.is_phone_communication_approved);
    const [showPhoneConfirm, setShowPhoneConfirm] = useState(false);
    const [phoneCode, setPhoneCode] = useState('');

    useEffect(() => {
        reset({
            first_name: state.customer.first_name,
            last_name: state.customer.last_name,
            phone: state.customer.phone ? '+7' + state.customer.phone : '',
            email: state.customer.email,
            birthday: state.customer.birthday ? moment(state.customer.birthday).format('YYYY-MM-DD') : null,
        })

        setGender(state.customer.gender)

    }, []);

    const send = async () => {

        setError('')
        setMessage('')
        const result = await trigger()

        if (!result) {
            setError('Не корректно заполнены поля формы')
            return
        }

        let fields: any = getValues()

        fields = {
            ...fields, ...{
                gender: gender,
                id: state.customer.id,
                sign: state.customer.sign,
                agree_email_communication: isEmailCommunicationApproved,
                agree_phone_communication: isPhoneCommunicationApproved
            }
        }

        if (!gender) {
            setError('Не указан пол')
            return
        }
        //
        dispatch({type: ReducerActionType.LOAD})
        updateApi(fields).then(status => {
            dispatch({type: ReducerActionType.SET_PARAM, paramName: 'customer', payload: status.user})
            dispatch({type: ReducerActionType.SUCCESS})
            setMessage('Данные обновлены')
        }).catch(error => {
            setError(error.response?.data?.detail || error.response?.data?.message)
        }).finally(() => {
            dispatch({type: ReducerActionType.SUCCESS})
        })
    }

    const confirmPhone = () => {

        setError('')


        const fields = getValues()

        if (!fields.phone) {
            setError('Не указан телефон пользователя')
            return
        }

        if (!state.customer.id || !state.customer.sign) {
            setError('Не указан ID пользователя или подпись')
            return
        }

        confirmPhoneApi(state.customer.id?.toString(), state.customer.sign, fields.phone).then(status => {
            setShowPhoneConfirm(true)
        }).catch(error => {
            setError(error.response?.data?.detail || error.response?.data?.message)
        })
    }

    const checkPhoneCodeLocal = () => {
        if (!state.customer.id) {
            setError('Не указан ID пользователя')
            return
        }
        if (!phoneCode) {
            setError('Не указан проверочный код')
            return
        }
        checkPhoneCode(state.customer.id, phoneCode, true).then(status => {
            setShowPhoneConfirm(false)
            dispatch({
                type: ReducerActionType.SET_PARAM,
                paramName: 'customer',
                payload: {...state.customer, is_phone_approved: true}
            })
            setMessage('Телефон подтвержден')
        }).catch(error => {
            setError(error.response?.data?.detail || error.response?.data?.message)
        })
    }

    const confirmEmail = () => {
        if (!state.customer.id || !state.customer.sign) {
            setError('Не указан ID пользователя или подпись')
            return
        }
        confirmEmailApi(state.customer.id, state.customer.sign).then(status => {
            setMessage('Письмо с подтверждением отправлено на ' + state.customer.email)
            dispatch({
                type: ReducerActionType.SET_PARAM,
                paramName: 'customer',
                payload: {...state.customer, is_email_approved: true}
            })
        }).catch(error => {
            setError(error.response?.data?.detail || error.response?.data?.message)
        })
    }

    return (<div
        className="tab-pane fade show active"
    >
        <form action="">
            <div className="row">
                <div className="col-md-6">
                    {error && <h3 className={'text-center text-danger'}>{error}</h3>}
                    {message && <h3 className={'text-center text-success'}>{message}</h3>}
                    <div className="form-line">
                        <label>Телефон</label>
                        <div className="form-group true">
                            <Controller
                                control={control}
                                name="phone"
                                rules={{
                                    required: true,
                                    validate: v => /^[+\d]{12,20}$/.test(v)
                                }}
                                render={({field: {onChange, name, value}}) => (
                                    <Input
                                        className={'form-control ' + (errors.phone ? ' is-invalid ' : '') + (!errors.phone && dirtyFields.phone ? ' is-valid ' : '')}
                                        placeholder="+7 ___ ___-__-__"
                                        name={name}
                                        onChange={onChange}
                                        value={value}
                                    />
                                )}
                            />
                            <i className="ico ico-check-circle-2"/>
                        </div>

                        {/*<div className="form-link ico-cont desk">*/}
                        {/*    <a href="">Изменить</a>*/}
                        {/*    <div className="hint">*/}
                        {/*        <i className="ico ico-right ico-question"/>*/}
                        {/*        <div className="hint__text" style={{display: "none"}}>*/}
                        {/*            <p>*/}
                        {/*                Lorem ipsum dolor sit amet consectetur, adipisicing*/}
                        {/*                elit. Aut officiis ullam nisi consectetur unde, quod*/}
                        {/*                omnis explicabo quasi et id quia cumque adipisci*/}
                        {/*                inventore ex ipsam saepe error asperiores*/}
                        {/*                necessitatibus.*/}
                        {/*            </p>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                    {!state.customer.is_phone_approved && !showPhoneConfirm &&
                        <div className="form-line">телефон не подтвержден, <span className={'dashed px-1 pointer'}
                                                                                 onClick={() => {
                                                                                     confirmPhone()
                                                                                 }}>подтвердить телефон</span></div>

                    }
                    {showPhoneConfirm && <div className="form-line">
                        <input type={'text'}
                               style={{width: '200px'}}
                               className={'form-control ' + (errors.phone_code ? ' is-invalid ' : '') + (!errors.phone_code && dirtyFields.phone_code ? ' is-valid ' : '')}
                               placeholder="введите код из СМС" value={phoneCode} onChange={(e) => {
                            setPhoneCode(e.target.value)
                        }}/> &nbsp;&nbsp;&nbsp;
                        <button type={"button"} className="btn btn-secondary btn-small ml-4" onClick={() => {
                            checkPhoneCodeLocal()
                        }}>
                            Подтвердить
                        </button>
                    </div>}
                    <div className="form-line">
                        <label>E-mail</label>
                        <div className="form-group ">

                            <input type="text"
                                   className={'form-control ' + (errors.email ? ' is-invalid ' : '') + (!errors.email && dirtyFields.email ? ' is-valid ' : '')}
                                   placeholder="введите email" {...register("email", {required: true,
                                validate: {
                                    checkEmail: v => !v || isEmail(v)
                                }
                            })}/>
                            {/*<p className="error-text">Неверный формат email</p>*/}
                            {/*<i className="ico ico-failed"/>*/}
                        </div>
                        {/*<div className="form-annotation">*/}
                        {/*    <p>*/}
                        {/*        Укажите e-mail, чтобы получать информацию по заказу и*/}
                        {/*        актуальным акциям. А мы начислим Вам 100 бонусов 🙂*/}
                        {/*    </p>*/}
                        {/*</div>*/}
                    </div>
                    {!state.customer.is_email_approved &&
                        <div className="form-line">email не подтвержден, <span className={'dashed px-1 pointer'}
                                                                               onClick={confirmEmail}>подтвердить email</span>
                        </div>}
                    <div className="form-line">
                        <label>Имя</label>
                        <div className="form-group">
                            <input type="text"
                                   className={'form-control ' + (errors.first_name ? ' is-invalid ' : '') + (!errors.first_name && dirtyFields.first_name ? ' is-valid ' : '')}
                                   placeholder="введите имя" {...register("first_name", {required: true})}/>

                            <i className="ico ico-color ico-eye-grey eye"/>
                        </div>
                    </div>
                    <div className="form-line">
                        <label>Фамилия</label>
                        <div className="form-group">
                            <input type="text"
                                   className={'form-control ' + (errors.last_name ? ' is-invalid ' : '') + (!errors.last_name && dirtyFields.last_name ? ' is-valid ' : '')}
                                   placeholder="введите фамилию" {...register("last_name", {required: true})}/>
                        </div>
                    </div>
                    <div className="form-line">
                        <label>Дата рождения</label>
                        <div className="form-group">
                            <input type="date"
                                   className={'form-control ' + (errors.birthday ? ' is-invalid ' : '') + (!errors.birthday && dirtyFields.birthday ? ' is-valid ' : '')}
                                   placeholder="введите дату рождения" {...register("birthday", {required: true})}/>
                        </div>
                        {/*<div className="form-annotation">*/}
                        {/*    <p>*/}
                        {/*        Никому не расскажем 😉 Но подготовим, что–то интересное*/}
                        {/*        на Ваш День рождения*/}
                        {/*    </p>*/}
                        {/*</div>*/}
                    </div>
                    <div className="form-line">
                        <label>Пол</label>
                        <div className="form-group">
                            <div className="form-radios">
                                <div className="form-radio">
                                    <div className={"form-radio " + (gender == 'm' && 'active')}>
                                        <label className="label-dot" onClick={() => setGender('m')}></label>
                                        <label className="label-text">Мужской</label>
                                    </div>
                                    <div className={"form-radio " + (gender == 'f' && 'active')}>
                                        <label className="label-dot" onClick={() => setGender('f')}></label>
                                        <label className="label-text">Женский</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div className="form-annotation">*/}
                        {/*    <p>*/}
                        {/*        Укажите Ваш пол, чтобы мы отправляли интересные для вас*/}
                        {/*        акции 💃🕺 . А с нас ещё 100 бонусов 🙂*/}
                        {/*    </p>*/}
                        {/*</div>*/}
                    </div>


                </div>
                <div className="col-md-5 mt-3">
                    <h5>Маркетинговые коммуникации</h5>
                    <div>Рекламно информационные рассылки позволят нам своевременно уведомлять вас о лучших предложениях
                        и поступлении нужных вам товаров
                    </div>
                    <div className="form-tumblers mt-3">
                        <div className="form-tumbler" onClick={() => {
                            setIsEmailCommunicationApproved(!isEmailCommunicationApproved)
                        }}>
                            <input className="hidden" type="checkbox" checked={isEmailCommunicationApproved}
                                   onChange={() => {
                                       setIsEmailCommunicationApproved(!isEmailCommunicationApproved)
                                   }}/>
                            <label className="label-dot"> <i/> </label>
                            <label className="label-text"> E-mail </label>
                        </div>
                        <div className="form-tumbler" onClick={() => {
                            setIsPhoneCommunicationApproved(!isPhoneCommunicationApproved)
                        }}>
                            <input className="hidden" type="checkbox" checked={isPhoneCommunicationApproved}/>
                            <label className="label-dot"> <i/> </label>
                            <label className="label-text"> SMS </label>
                        </div>

                    </div>
                </div>
                <div className="col-md-6 mt-3">
                    <div className="form-line">
                        <div className="form-group">
                            <div className="form-btns form-btns--full">
                                <button type={"button"} className="btn btn-secondary" onClick={() => {
                                    send()
                                }}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={'text-muted '}>ID: {state.customer.id}</div>
                </div>

            </div>
        </form>


    </div>)
}